import React from "react";

const Footer = () => {
  return (
    <>
      <div className="straph">
        <div className="container">
          <div className="row font10">
            <div className="col-md-4 text-center">
              Need help? &nbsp;
              <i className="fa fa-phone" aria-hidden="true"></i> +91 48442 91114
            </div>
            <div className="col-md-4 text-center">
              Monday to Friday 9 AM to 6 PM{" "}
            </div>
            <div className="col-md-4 text-center">
              Follow Us
              <a
                className="s-icin"
                href="https://www.facebook.com/myacumencapital"
                target="_blank"
                rel="noreferrer"
              >
                <i className="fa fa-facebook pl-3 pr-3" aria-hidden="true"></i>
              </a>
              <a
                className="s-icin"
                href="https://www.instagram.com/myacumengroup/"
                target="_blank"
                rel="noreferrer"
              >
                <i className="fa fa-instagram pr-3" aria-hidden="true"></i>
              </a>
              <a
                className="s-icin"
                href="https://www.linkedin.com/company/acumen-capital-market"
                target="_blank"
                rel="noreferrer"
              >
                <i className="fa fa-linkedin pr-3" aria-hidden="true"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
      <footer className="rekyc-footer">
        <div className="container-fluid">
          <div className="row  mt-5  text-md-left">
            <div className="col-md-12 rekyc-portal">
              <div className="container">
                <p className="small">
                  Disclaimer: Acumen Capital Market India Ltd does not guarantee
                  any fixed returns. Investment in the securities market is
                  subject to market risks, read all the related documents
                  carefully before investing.
                </p>
                <p className="small">
                  Refer{" "}
                  <a
                    href="https://acumengroup.in/Documents/Acumen%20sebi-investor-charter-stock-broker.pdf"
                    target="_blank"
                    without="true"
                    rel="noreferrer"
                  >
                    Investor Charter
                  </a>
                </p>
                <p className="small">
                  General queries:{" "}
                  <a href="mailto:care@acumengroup.in">care@acumengroup.in</a> |
                  Grievances (Exchange/DP):{" "}
                  <a href="mailto:grievances@acumengroup.in">
                    grievances@acumengroup.in.
                  </a>{" "}
                  | Compliance:{" "}
                  <a href="mailto:admin@acumengroup.in">admin@acumengroup.in</a>{" "}
                  | Procedure to file a complaint on{" "}
                  <a
                    href="https://scores.sebi.gov.in/"
                    target="_blank"
                    rel="noreferrer"
                  >
                    SEBI SCORES
                  </a>{" "}
                  Register on the SCORES portal. Mandatory details for filing
                  complaints on SCORES: Name, PAN, Address, Mobile Number,
                  E-mail ID. Benefits: Effective Communication, Speedy redressal
                  of grievances. Please ensure you carefully read{" "}
                  <a
                    href="https://acumengroup.in/terms-conditions"
                    target="_blank"
                    rel="noreferrer"
                  >
                    {" "}
                    terms & conditions{" "}
                  </a>{" "}
                  &{" "}
                  <a
                    href="https://acumengroup.in/privacy-policy."
                    target="_blank"
                    rel="noreferrer"
                  >
                    Privacy policy.{" "}
                  </a>
                </p>
                <p className="small">
                  Registered office : Acumen Capital Market India Ltd, S.T
                  Reddiar & Sons, Veekshanam Road, Kochi Pin: 682035,
                  0484-4291111 I Website:{" "}
                  <a
                    href="https://www.acumengroup.in"
                    target="_blank"
                    rel="noreferrer"
                  >
                    www.acumengroup.in{" "}
                  </a>
                  | SEBI Regn. Nos. : INZ000170434 | NSDL Reg no: IN-DP-40-2015
                  | CDSL Reg. no: IN-DP-CDSL-680-2013 | INH 200003026 | Company
                  Identification Number (CIN): U67120KL1995PLC008674.
                </p>
              </div>
            </div>
            <div className="container bottom_border text-center mt-3 mb-3 ftr-privacy">
              <ul>
                <li>
                  <a
                    target="_blank"
                    rel="noreferrer"
                    href="https://www.sebi.gov.in/"
                  >
                    SEBI
                  </a>{" "}
                </li>
                <li>
                  <a
                    target="_blank"
                    rel="noreferrer"
                    href="https://www.nseindia.com/"
                  >
                    NSE
                  </a>{" "}
                </li>
                <li>
                  <a
                    target="_blank"
                    rel="noreferrer"
                    href="https://www.bseindia.com/static/investors/services.aspx"
                  >
                    BSE
                  </a>{" "}
                </li>
                <li>
                  <a
                    target="_blank"
                    rel="noreferrer"
                    href="https://www.mcxindia.com/membership/members-compliance/vernacular-language"
                  >
                    MCX
                  </a>{" "}
                </li>
                <li>
                  <a
                    target="_blank"
                    rel="noreferrer"
                    href="https://nsdl.co.in/"
                  >
                    NSDL
                  </a>{" "}
                </li>
                <li>
                  <a
                    target="_blank"
                    rel="noreferrer"
                    href="https://www.cdslindia.com/"
                  >
                    CDSL
                  </a>{" "}
                </li>
              </ul>
            </div>
          </div>
          <div className="copyright text-center pb-2">
            <p>
              <b>
                Copyright © 2022{" "}
                <a
                  href="https://www.acumengroup.in"
                  target="_blank"
                  rel="noreferrer"
                >
                  Acumen Capital Market (India) Limited.
                </a>{" "}
                All Rights Reserved.
              </b>
            </p>
          </div>
        </div>
      </footer>
    </>
  );
};
export default Footer;
